import { render, staticRenderFns } from "./RecommendedEvent.vue?vue&type=template&id=311e8600&scoped=true&"
import script from "./RecommendedEvent.vue?vue&type=script&lang=js&"
export * from "./RecommendedEvent.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedEvent.vue?vue&type=style&index=0&id=311e8600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311e8600",
  null
  
)

export default component.exports